import { homApi } from '~/redux/apis/hom'

import { USER_API_TAGS, ACCOUNT_API_TAGS } from '~/redux/constants/tags.const'

import { invalidateOnSuccess } from '../utils/util'

export const accountsApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getVerifyStatus: builder.query<{ mustVerifyEmail: boolean; mayVerifyEmail: boolean }, void>({
      query: () => ({
        url: '/v1/accounts/verify-status',
        method: 'GET',
      }),
      providesTags: [ACCOUNT_API_TAGS.EmailVerifyStatus],
    }),
    sendVerifyEmailByKey: builder.mutation<{ message: 'success'; email: string }, { key: string }>({
      query: (body) => ({
        url: '/v1/accounts/resend-verify-email',
        method: 'POST',
        body,
      }),
    }),

    sendVerifyMail: builder.mutation<{ message: 'success'; email: string }, { key: string }>({
      query: (body) => ({
        url: '/v1/accounts/send-verification-email',
        method: 'POST',
        body,
      }),
      invalidatesTags: invalidateOnSuccess([USER_API_TAGS.UserMe, ACCOUNT_API_TAGS.EmailVerifyStatus]),
    }),

    verifyEmail: builder.mutation<void, { key: string }>({
      query: (body) => ({
        url: '/v1/accounts/verify-email',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: invalidateOnSuccess([USER_API_TAGS.UserMe, ACCOUNT_API_TAGS.EmailVerifyStatus]),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSendVerifyEmailByKeyMutation,
  useVerifyEmailMutation,
  useGetVerifyStatusQuery,
  useLazyGetVerifyStatusQuery,
  useSendVerifyMailMutation,
} = accountsApi
